import { applyMask, stripToDigits } from '@noor/lib';

/** Uzbek numbers are `998` + 9 national digits. */
const UZ_CODE = '998';
const UZ_NATIONAL_LENGTH = 9;

/**
 * Format a stored E.164 phone for display: `+998901234567` →
 * `+998 (90) 123 45 67`, the grouping the Figma cards use (26295:98911).
 *
 * Storage stays canonical E.164 (CLAUDE.md: formatted controls keep the
 * canonical value; presentation is a view concern), so this is display-only.
 * Anything that is not a full Uzbek number — a foreign number, or a partial one
 * — is returned as-is rather than forced into a mask that would misgroup it.
 */
export function formatUserPhone(phone: string): string {
  const digits = stripToDigits(phone);
  if (!digits.startsWith(UZ_CODE)) return phone;

  const national = digits.slice(UZ_CODE.length);
  if (national.length !== UZ_NATIONAL_LENGTH) return phone;

  return `+${UZ_CODE} ${applyMask(national, '(##) ### ## ##')}`;
}
